module.exports = __webpack_public_path__ + "static/media/tooltip.76bd40e7.svg";